import React from 'react';
import CommonCtaArea from '../../components/CommonCtaArea/CommonCtaArea';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import Footer from '../../components/shared/Footer';
import PageHelmet from '../../components/shared/PageHelmet';
import HomeCapabilities from '../Home/HomeCapabilities/HomeCapabilities';
import HomeOneHeader from '../Home/HomeOneHeader/HomeOneHeader';
import HomeServices from '../Home/HomeServices/HomeServices';
import HomeTwoFeatures from '../Home/HomeTwoFeatures/HomeTwoFeatures';

const Services = () => {
   return (
      <>
         <PageHelmet pageTitle="JRD Transportation Services" />

         <HomeOneHeader/>
         <CommonPageHeader title="Our Services" subtitle="Services" />
         <HomeServices />
         <HomeCapabilities/>
         <HomeTwoFeatures/>
         <CommonCtaArea/>
         <Footer/>
      </>
   );
};

export default Services;